export default "__VITE_ASSET__BzDgBA6a__"